// @ts-nocheck
export const localeCodes =  [
  "en",
  "zh",
  "kr",
  "tr"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_7c112116",
      load: () => import("#nuxt-i18n/7c112116" /* webpackChunkName: "locale_en_46ts_7c112116" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_cn_46ts_d195c1e2",
      load: () => import("#nuxt-i18n/d195c1e2" /* webpackChunkName: "locale_cn_46ts_d195c1e2" */),
      cache: false
    }
  ],
  kr: [
    {
      key: "locale_kr_46ts_2e177d66",
      load: () => import("#nuxt-i18n/2e177d66" /* webpackChunkName: "locale_kr_46ts_2e177d66" */),
      cache: false
    }
  ],
  tr: [
    {
      key: "locale_tr_46ts_6ada3f8e",
      load: () => import("#nuxt-i18n/6ada3f8e" /* webpackChunkName: "locale_tr_46ts_6ada3f8e" */),
      cache: false
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/52dd2c8f" /* webpackChunkName: "config_i18n_46config_46ts_52dd2c8f" */)
]
export const normalizedLocales = [
  {
    code: "en",
    name: "En",
    longName: "English",
    language: undefined
  },
  {
    code: "zh",
    name: "中文",
    longName: "中文",
    language: undefined
  },
  {
    code: "kr",
    name: "Kr",
    longName: "한국어",
    language: undefined
  },
  {
    code: "tr",
    name: "Tr",
    longName: "Türkçe",
    language: undefined
  }
]
/** client **/

/** client-end **/